import { Link } from "react-router-dom";

export default function About() {
  return (
    <section id="about" className="py-24 bg-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img
                src="/assets/About.jpg"
                alt="Ester LifeSciences Facility"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <div className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              ABOUT Ester LifeSciences
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Leading Provider of Cardiac &amp; Diabetic Medicines
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-4">
              Ester LifeSciences is a leading pharmaceutical company dedicated to providing high-quality cardiovascular and diabetic medicines. With over a decade of experience, we have established ourselves as a trusted partner for healthcare professionals and patients worldwide.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-4">
              We specialize in sourcing and distributing premium pharmaceutical products that adhere to the highest international quality standards. Our commitment is to ensure effective cardiac care, diabetic management, and treatment solutions for acute and chronic diseases reach those who need them most.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              At Ester LifeSciences, we believe in building lasting relationships with healthcare providers, ensuring that our products not only meet but exceed expectations in efficacy, safety, and reliability.
            </p>

            <div className="grid grid-cols-3 gap-6 mb-8">
              <div>
                <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
                <div className="text-sm text-gray-600">Healthcare Partners</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-blue-600 mb-2">10</div>
                <div className="text-sm text-gray-600">Specialized Products</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-blue-600 mb-2">15+</div>
                <div className="text-sm text-gray-600">Years Experience</div>
              </div>
            </div>

            <Link to="/about" className="bg-blue-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer">
              Our Story
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
